import { Field, Form, Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  userid,
  currentTenant,
  financialyearstart,
  financialyearend,
  transactionFrom,
} from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import PurchaseServices from "../../Purchase/PurchseServices.js";
import "date-fns";
import Grid from "@mui/material/Grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Autocomplete,
  Backdrop,
  CircularProgress,
  TextField,
} from "@mui/material";

import InventoryService from "../InventoryService.js";
import { Spinner } from "react-bootstrap";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices.js";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Swal from "sweetalert2";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import dayjs from 'dayjs';
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";

const AddStock = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // FIX: Safely handle null/undefined location.state
  const locationState = location.state || {};
  const locationPagename = locationState.pagename || "Add Stock";
  const locationId = locationState.id || -1;
  const locationData = locationState.data || undefined;
  const locationStocktype = locationState.stocktype || "Own";

  // Modern styling inspired by NewItem.jsx
  const styles = {
    stockHigh: { color: '#5f8f3f', fontWeight: 500 },
    stockMedium: { color: '#5f8f3f', fontWeight: 500 },
    stockLow: { color: '#dc2626', fontWeight: 500 },
    checkboxRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: '16px',
      gap: '20px',
      flexWrap: 'wrap',
    },
    checkboxContainer: {
      minWidth: '250px',
    },
    datePickerContainer: {
      width: '300px',
    },
    supplierContainer: {
      width: '300px',
      display: 'flex',
      flexDirection: 'column',
    },
    modernDatePicker: {
      '& .MuiInputBase-root': {
        borderRadius: '6px',
        padding: '6px',
        height: '40px',
        width: '100%',
        fontSize: '0.85rem',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#d1d5db',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#4d4d4d',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#4d4d4d',
        borderWidth: '1px',
      },
    },
    formGroup: {
      marginBottom: '16px',
    },
    label: {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: '#1e293b',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    },
    input: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.8rem',
      outline: 'none',
      transition: 'all 0.01s ease',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box',
    },
    inputFocus: {
      borderColor: '#4d4d4d',
      boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.1)',
    },
    inputError: {
      borderColor: '#dc2626',
      boxShadow: '0 0 0 2px rgba(220, 38, 38, 0.1)',
    },
    inputDisabled: {
      backgroundColor: '#f8fafc',
      color: '#64748b',
      cursor: 'not-allowed',
    },
    checkbox: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '0.8rem',
      color: '#4d4d4d',
      padding: '8px',
      backgroundColor: '#f8fafc',
      borderRadius: '6px',
      border: '1px solid #e2e8f0',
    },
    checkboxInput: {
      accentColor: '#4d4d4d',
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
    btnPrimary: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    btnOutline: {
      backgroundColor: '#ffffff',
      color: '#4d4d4d',
      border: '1px solid #4d4d4d',
    },
    btnSecondary: {
      backgroundColor: '#f8fafc',
      color: '#374151',
      border: '1px solid #d1d5db',
    },
    btnDanger: {
      backgroundColor: '#dc2626',
      color: '#ffffff',
    },
    btnSuccess: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    btnActions: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-end',
      paddingTop: '16px',
      borderTop: '1px solid #e2e8f0',
      marginTop: '24px',
    },
    helperText: {
      color: '#64748b',
      fontSize: '0.7rem',
      marginTop: '2px',
      marginLeft: '12px'
    },
    radioGroup: {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
    },
    radioOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.8rem',
      color: '#374151',
      cursor: 'pointer',
      verticalAlign: 'middle',
    },
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #e2e8f0',
      borderTop: '4px solid #4d4d4d',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
  };

  const [state, setState] = useState({
    pagename: locationPagename,
    id: "",
    sid: locationId,
    cid: "",
    name: "",
    cost: "",
    stock: "",
    itemsList: [],
    model: "",
    brand: "",
    costList: [],
    WarehouseList: [],
    suppliers: [],
    supplier: "",
    supplierid: "",
    purchasedate: new Date(),
    descreption: "",
    wid: locationData ? locationData.whid : "",
    warehouse: locationData ? locationData.warehouse : "",
    selectvalue: "",
    mfdate: new Date(),
    expdate: new Date(),
    loader: false,
    minnotifier: "",
    status: locationData ? "Finished Goods" : (locationStocktype === "ThirdParty" ? "Internal Use" : "Raw Material"),
    istatus: "Asset",
    stocktypes: [
      "Internal Use",
      "Reselling",
      "Raw Material",
      "Finished Goods",
    ],
    stockitemtypes: ["Asset", "Consumption"],
    assettypes: ["Own", "ThirdParty"],
    assettype: locationData ? "Own" : locationStocktype,
    data: locationData,
    prevstock: 0,
    uomid: "",
    uom: "",
    addmfdate: false,
    addexpdate: false,
    stockfrom: locationData ? locationData.type : "Direct",
    openingexists: false,
    openingstkstatus: false,
    byproduct: false,
    productionid: locationData && locationData.data ? (locationData.data.imp === null ? locationData.data.joid : locationData.data.imp) : null,
    cdate: false,
    customdate: new Date(),
    hovered: null,
    errors: {},
    vendorBatchCode: "",
  });

  const [selectedPriceOption, setSelectedPriceOption] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(locationId > -1); // Track if we're in update mode

  const updateState = (newState) => {
    setState(prevState => ({ ...prevState, ...newState }));
  };

  const handlecreatedAtDateChange = (date) => {
    updateState({
      customdate: date,
      fed: moment(date).format("yyyy-MM-DD HH:mm:ss")
    });
  };

  const handlecustomDate = () => {
    updateState({
      cdate: !state.cdate,
      customdate: new Date(),
    });
  };

  const handleSelect = (e) => {
    updateState({ status: e.target.value });
  };

  const handleChange = (e) => {
    updateState({ istatus: e.target.value });
  };

  const handleAssetTypeChange = (e) => {
    updateState({ assettype: e.target.value });
  };

  const handleStockChange = (e) => {
    updateState({ stock: e.target.value });
  };

  const handlevendorBatchCode = (e) => {
    updateState({ vendorBatchCode: e.target.value });
  };

  const handleminnotifier = (e) => {
    updateState({ minnotifier: parseFloat(e) });
  };

  const handleaddmfdate = (e) => {
    updateState({ addmfdate: e.target.checked });
  };

  const handleaddexpdate = (e) => {
    updateState({ addexpdate: e.target.checked });
  };

  const handlewarehouse = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      updateState({ wid: values.id, warehouse: values.name });
    } else {
      updateState({ wid: "", warehouse: "" });
    }
  };

  const handlesupplier = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      if (values.ledgerid === null || values.ledgerid === undefined) {
        alert(
          `Ledger account is not created for supplier ${values.companyname}, so no payment or receipt can be done`
        );
      }
      updateState({
        supplierid: values.id,
        supplier: values.companyname,
      });
    } else {
      updateState({
        supplierid: "",
        supplier: "",
      });
    }
  };

  const handleitemname = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      updateState({
        id: values.id,
        name: values.name,
        cid: "",
        cost: "",
        brand: values.brand,
        model: values.model,
        uom: values.uomname,
        uomid: values.uomid,
      });

      const itemId = values.id;
      InventoryService.costDataById(itemId)
        .then((response) => {
          const costList = response.data;
          updateState({ costList });

          // Auto-select the price if there's only one price
          if (costList && costList.length === 1) {
            const singlePrice = costList[0];
            updateState({
              cid: singlePrice.cid,
              cost: singlePrice.rate
            });
            // Also set the selected option for the Autocomplete
            setSelectedPriceOption(singlePrice);
          } else {
            setSelectedPriceOption(null);
          }
        })
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            navigate(`/`);
          }
        });

      InventoryService.ExistbyItem(currentTenant, itemId).then((response) => {
        updateState({ openingexists: response.data });
      });
    } else {
      updateState({
        id: "",
        name: "",
        cid: "",
        cost: "",
        brand: "",
        model: "",
      });
      setSelectedPriceOption(null);
    }
  };

  const handlecost = (value, values) => {
    if (values !== "" && typeof values === "object" && values !== null) {
      updateState({ cid: values.cid, cost: values.rate });
      setSelectedPriceOption(values);
    } else {
      updateState({ cid: "", cost: "" });
      setSelectedPriceOption(null);
    }
  };

  const handlePurchaseDateChange = (date) => {
    updateState({ purchasedate: date });
  };

  const handleMfDateChange = (date) => {
    updateState({ mfdate: date });
  };

  const handleExpDateChange = (date) => {
    updateState({ expdate: date });
  };

  const validate = (values) => {
    let errors = {};

    // Only validate warehouse and item in add mode, not update mode
    if (!isUpdateMode) {
      if (
        state.wid === "" ||
        state.wid === undefined ||
        state.warehouse === ""
      ) {
        errors.warehouse = "Please Select Org Unit";
      }

      if (!values.name || values.name === "") {
        errors.name = "Please Select An Item";
      }
    }

    if (state.stock === "") {
      errors.stock = "Stock value is required";
    }
    if (state.stock <= 0) {
      errors.stock = "Stock value should be greater than 0";
    }

    if (!state.cost || state.cost === "") {
      errors.cost = "Please Select a Price";
    }

    if (
      !isUpdateMode && // Only validate supplier in add mode
      state.openingstkstatus === false &&
      state.byproduct === false &&
      state.supplierid === "" &&
      state.data === undefined
    ) {
      errors.supplier = "Please Select Supplier";
    }
    return errors;
  };

  const onSubmit = (values) => {
    console.log("Form submitted, isUpdateMode:", isUpdateMode);
    const errors = validate(values);
    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      updateState({ errors });
      return;
    }

    updateState({ loader: true });

    let addstock = {
      id: state.id,
      wid: state.wid,
      name: state.name,
      supplier: state.supplier,
      supplierid: state.supplierid === "" ? null : state.supplierid,
      currentStock: parseFloat(state.stock),
      cid: state.cid,
      createdby: userid,
      tenantid: currentTenant,
      manufacturingdate: state.mfdate,
      expirydate: state.expdate,
      minnotifier: state.minnotifier,
      status:
        state.status === "Internal Use"
          ? 0
          : state.status === "Reselling"
            ? 1
            : state.status === "Raw Material"
              ? 2
              : 3,
      itemtype:
        state.status === "Internal Use"
          ? state.istatus === "Asset"
            ? 1
            : 2
          : 0,
      fsid: state.data === undefined ? -1 : state.data.items.id,
      stockfrom: state.stockfrom,
      purchasedate: state.purchasedate,
      addmfdate: state.addmfdate,
      addexpdate: state.addexpdate,
      isopening: state.openingstkstatus,
      productionid: state.productionid,
      customdate: state.customdate,
      cdate: state.cdate,
      atype: state.assettype === "Own" ? 0 : 1,
      byproduct: state.byproduct,
      rate: state.cost,
      vendorBatchCode: state.vendorBatchCode,
    };

    let updatestock = {
      id: state.sid, // Stock ID
      sid: state.sid, // Also include sid for compatibility
      wid: state.wid,
      cid: state.cid,
      name: state.name,
      supplier: state.supplier,
      supplierid: state.supplierid,
      prevstock: state.prevstock,
      currentStock: parseFloat(state.stock),
      updatedby: userid,
      tenantid: currentTenant,
      minnotifier: state.minnotifier,
      manufacturingdate: state.mfdate,
      expirydate: state.expdate,
      status:
        state.status === "Internal Use"
          ? 0
          : state.status === "Reselling"
            ? 1
            : state.status === "Raw Material"
              ? 2
              : 3,
      itemtype:
        state.status === "Internal Use"
          ? state.istatus === "Asset"
            ? 1
            : 2
          : 0,
      purchasedate: state.purchasedate,
      addmfdate: state.addmfdate,
      addexpdate: state.addexpdate,
      isopening: state.openingstkstatus,
      atype: state.assettype === "Own" ? 0 : 1,
      byproduct: state.byproduct,
      vendorBatchCode: state.vendorBatchCode,
      rate: state.cost,
    };

    console.log("Update stock payload:", updatestock);

    if (isUpdateMode) {
      // Update stock logic
      console.log("Calling updateStock API...");
      InventoryService.updateStock(updatestock)
        .then((response) => {
          console.log("Update successful:", response);
          updateState({ loader: false });
          Swal.fire({
            title: `Stock updated successfully`,
            text: ".",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          }).then(() => navigate(`/stocks`));
        })
        .catch((e) => {
          console.error("Update error:", e);
          console.error("Error response:", e.response);
          updateState({ loader: false });
          if (e.response?.data?.error === "Unauthorized") {
            Swal.fire({
              title: `Your Session is Lost: Please login Back to resume`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate("/"));
          } else {
            Swal.fire({
              title: `${e.response?.data?.message || e.message || "Update failed"}`,
              text: ".",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            });
          }
        });
    } else {
      // Add stock logic
      console.log("Calling addStock API...");
      if (
        state.status === "Internal Use" &&
        state.istatus === "Asset" &&
        state.assettype === "ThirdParty"
      ) {
        InventoryService.addthirdpartystock(addstock)
          .then(() => {
            updateState({ loader: false });
            Swal.fire({
              title: `Thirdparty Stock added successfully`,
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate(`/stocks`));
          })
          .catch((e) => {
            updateState({ message: e.response?.data?.message, loader: false });
            if (e.response?.data?.error === "Unauthorized") {
              Swal.fire({
                title: `Your Session is Lost: Please login Back to resume`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              }).then(() => navigate("/"));
            } else {
              Swal.fire({
                title: `${e.response?.data?.message || e.message}`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              });
            }
          });
      } else {
        InventoryService.addStock(addstock)
          .then(() => {
            updateState({ loader: false });
            Swal.fire({
              title: `Stock added successfully`,
              text: ".",
              icon: "success",
              confirmButtonText: "Ok",
              confirmButtonColor: "#152f5f",
            }).then(() => navigate(`/stocks`));
          })
          .catch((e) => {
            updateState({ message: e.response?.data?.message, loader: false });
            if (e.response?.data?.error === "Unauthorized") {
              Swal.fire({
                title: `Your Session is Lost: Please login Back to resume`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              }).then(() => navigate("/"));
            } else {
              Swal.fire({
                title: `${e.response?.data?.message || e.message}`,
                text: ".",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#152f5f",
              });
            }
          });
      }
    }
  };

  const onstockfocus = () => {
    const stockElement = document.getElementById("stock");
    if (stockElement) {
      stockElement.addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
      stockElement.addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
    }
  };

  const onfocus = () => {
    const minnotifierElement = document.getElementById("minnotifier");
    if (minnotifierElement) {
      minnotifierElement.addEventListener("mousewheel", function (event) {
        if (window.document.activeElement.type === "number") {
          event.preventDefault();
        }
      });
      minnotifierElement.addEventListener("keydown", function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
    }
  };

  useEffect(() => {
    // FIX: Add safety check for userid
    if (!userid) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      navigate(`/`);
      return;
    }

    console.log("Location state:", location.state);
    const sid = location?.state?.id;
    console.log("Stock ID from location:", sid);
    console.log("Production ID:", state.productionid);

    // Set update mode based on sid
    const updateMode = sid > -1;
    setIsUpdateMode(updateMode);
    console.log("Update mode set to:", updateMode);

    WarehouseServices.getWarehouses(currentTenant)
      .then((response) => {
        updateState({ WarehouseList: response.data });
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate(`/`);
        }
      });

    PurchaseServices.GetAllSellers(currentTenant).then((res) => {
      updateState({ suppliers: res.data });
    });

    InventoryService.retriveAllItems(currentTenant).then((res) => {
      updateState({ itemsList: res.data.filter((e) => e.cost !== null) });
    });

    if (location.state && location.state?.items) {
      updateState({
        id: location.state.items?.id,
        name: location.state.items?.name,
        brand: location.state.items?.brand,
        model: location.state.items?.model,
        uom: location.state.items?.uomname,
        uomid: location.state.items?.uom,
      });
      InventoryService.costDataById(location.state.items?.id)
        .then((response) => {
          const costList = response.data;
          updateState({ costList });

          const preCid = location.state?.preselectedCid;
          if (preCid) {
            const preselectedCost = costList.find(c => c.cid === preCid);
            if (preselectedCost) {
              updateState({
                cid: preselectedCost.cid,
                cost: preselectedCost.rate
              });
              setSelectedPriceOption(preselectedCost);
            }
          } else if (costList && costList.length === 1) {
            // Auto-select the price if there's only one price
            const singlePrice = costList[0];
            updateState({
              cid: singlePrice.cid,
              cost: singlePrice.rate
            });
            // Also set the selected option for the Autocomplete
            setSelectedPriceOption(singlePrice);
          }
        })
        .catch((e) => {
          if (e.response?.data?.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            navigate(`/`);
          }
        });
    }

    if (sid > -1) {
      console.log("Fetching stock data for update, sid:", sid);
      InventoryService.stockDataToUpdate(sid).then((response) => {
        const stockData = response.data;
        console.log("Stock data received:", stockData);
        updateState({
          sid: sid,
          id: stockData.id,
          name: stockData.name,
          warehouse: stockData.waddress,
          supplier: stockData.supplier,
          supplierid: stockData.supplierid,
          stock: stockData.currentStock,
          cost: stockData.rate,
          mfdate: stockData.manufacturingdate ? new Date(stockData.manufacturingdate) : new Date(),
          expdate: stockData.expirydate ? new Date(stockData.expirydate) : new Date(),
          cid: stockData.cid,
          wid: stockData.wid,
          minnotifier: stockData.minnotifier,
          prevstock: stockData.currentStock,
          status:
            stockData.stocktype === "INTERNALUSE"
              ? "Internal Use"
              : stockData.stocktype === "RESALE"
                ? "Reselling"
                : stockData.stocktype === "RAWMATERIAL"
                  ? "Raw Material"
                  : "Finished Goods",
          istatus:
            stockData.stockitemtype === "ASSET"
              ? "Asset"
              : stockData.stockitemtype === "CONSUMPTION"
                ? "Consumption"
                : "Asset",
          addmfdate: stockData.addmfdate || false,
          addexpdate: stockData.addexpdate || false,
          purchasedate: stockData.purchasedate ? new Date(stockData.purchasedate) : new Date(),
          vendorBatchCode: stockData.vendorBatchCode || "",
          assettype: stockData.assettype === "THIRDPARTY" ? "ThirdParty" : "Own",
        });

        // Also set the selected price option for the Autocomplete
        if (stockData.cid && stockData.rate) {
          setSelectedPriceOption({ cid: stockData.cid, rate: stockData.rate });
        }

        // Fetch cost list for the item
        if (stockData.id) {
          InventoryService.costDataById(stockData.id)
            .then((costResponse) => {
              updateState({ costList: costResponse.data });
            })
            .catch((e) => {
              console.error("Error fetching cost list:", e);
            });
        }
      }).catch((e) => {
        console.error("Error fetching stock data:", e);
        updateState({ loader: false });
      });
    }
  }, [location]);

  const getStockStatus = (stock) => {
    const value = stock ?? 0;
    if (value > 5) return { text: value, style: styles.stockHigh };
    if (value > 3) return { text: value, style: styles.stockMedium };
    return { text: value, style: styles.stockLow };
  };

  const setHovered = (value) => {
    updateState({ hovered: value });
  };

  const {
    id,
    name,
    stock,
    cost,
    cid,
    warehouse,
    wid,
    minnotifier,
    status,
    istatus,
    brand,
    model,
    uom,
    suppliers,
    supplier,
    supplierid,
    pagename,
    loader,
    itemsList,
    costList,
    WarehouseList,
    data,
    sid,
    openingexists,
    openingstkstatus,
    byproduct,
    addmfdate,
    addexpdate,
    mfdate,
    expdate,
    purchasedate,
    cdate,
    customdate,
    assettype,
    productionid,
    errors,
    hovered,
    vendorBatchCode,
  } = state;

  return (
    <div>
      {/* <Header />
      <Menu /> */}
      <div className="UI-container">
        <div className="UI-card">
          <div className="UI-header">
             <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Stocks",path:"/stocks"},{name:pagename,path:null}]}/>

            <div className="UI-header-content">
              <div>
                <h1 className="UI-title">
                  {pagename}
                </h1>
                <p className="UI-subtitle">
                  {pagename === "Update Stock" ? "Modify existing stock batch details" : "Add new stock batch to inventory"}
                </p>
              </div>
              <div className="UI-header-actions">
                <Link
                  to="/stocks"
                  className="UI-btn UI-btn-outline"
                >
                  ← Back
                </Link>
              </div>
            </div>
          </div>

          <div className="UI-form-container">
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>

            <Formik
              initialValues={{
                id,
                name,
                stock,
                cost,
                cid,
                warehouse,
                wid,
                minnotifier,
                status,
                istatus,
                brand,
                model,
                uom,
                suppliers,
                supplier,
                supplierid,
                vendorBatchCode,
              }}
              onSubmit={onSubmit}
              validateOnChange={false}
              validate={validate}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form autoComplete="off">
                  {!isUpdateMode &&
                    (itemsList === undefined ||
                      itemsList.length === 0) ? (
                    <div style={{
                      backgroundColor: '#fef2f2',
                      border: '1px solid #fecaca',
                      borderRadius: '6px',
                      padding: '12px',
                      marginBottom: '16px'
                    }}>
                      <ul style={{ padding: 0, margin: 0, textAlign: 'center', fontSize: '0.8rem' }}>
                        {itemsList === undefined ||
                          itemsList.length === 0 ? (
                          <li>No Items are Available.</li>
                        ) : (
                          openingexists && "Make sure all the details of the item/product are correct, once stock is added you cannot modify details of the item/product "
                        )}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}

                  {assettype === "ThirdParty" ? "" : (
                    <>
                      <div className="UI-form-section">
                        <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Stock Type</h3>
                        <div style={styles.radioGroup}>
                          <FormLabel style={{ marginRight: '16px', fontSize: '0.8rem' }}>
                            Stock Type:
                          </FormLabel>
                          <RadioGroup
                            row
                            value={status}
                            onChange={handleSelect}
                          >
                            {state.stocktypes.map((e) => {
                              return (
                                <FormControlLabel
                                  key={e}
                                  value={e}
                                  control={
                                    <Radio
                                      style={{ color: "#4d4d4d" }}
                                      disabled={data !== undefined || location.state?.stocktype === "ThirdParty" || isUpdateMode}
                                    />
                                  }
                                  label={e}
                                  style={styles.radioOption}
                                />
                              );
                            })}
                          </RadioGroup>
                        </div>
                      </div>

                      {status === "Internal Use" ? (
                        <div className="UI-form-section">
                          <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Internal Consumption Type</h3>
                          <div style={styles.radioGroup}>
                            <FormLabel style={{ marginRight: '16px', fontSize: '0.8rem' }}>
                              Internal Consumption Type:
                            </FormLabel>
                            <RadioGroup
                              row
                              value={istatus}
                              onChange={handleChange}
                            >
                              {state.stockitemtypes.map((e) => {
                                return (
                                  <FormControlLabel
                                    key={e}
                                    value={e}
                                    control={
                                      <Radio style={{ color: "#4d4d4d" }} disabled={location.state?.stocktype === "ThirdParty" || isUpdateMode} />
                                    }
                                    label={e}
                                    style={styles.radioOption}
                                  />
                                );
                              })}
                            </RadioGroup>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  <div className="UI-form-section">
                    <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Basic Batch Information</h3>
                    <div className="UI-form-grid">
                      {isUpdateMode ||
                        data !== undefined ? (
                        <>
                          {data !== undefined ? (
                            ""
                          ) : (
                            <div style={styles.formGroup}>
                              <label style={styles.label}>Supplier</label>
                              <input
                                type="text"
                                value={supplier}
                                style={{
                                  ...styles.input,
                                  ...styles.inputDisabled
                                }}
                                disabled
                              />
                            </div>
                          )}

                          <div style={styles.formGroup}>
                            <label style={styles.label}>Org Unit</label>
                            <input
                              type="text"
                              value={warehouse}
                              style={{
                                ...styles.input,
                                ...styles.inputDisabled
                              }}
                              disabled
                            />
                          </div>
                          <div style={styles.formGroup}>
                            <label style={styles.label}>Item</label>
                            <input
                              type="text"
                              value={name}
                              style={{
                                ...styles.input,
                                ...styles.inputDisabled
                              }}
                              disabled
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={styles.formGroup}>
                            <AutoCompeteField id="warehouse" name="warehouse" options={WarehouseList} label="Org Unit" labelKey={"name"} valueKey={"id"} onChange={handlewarehouse} value={wid} required  error={errors.warehouse} disabled={data !== undefined}/>
                            {/* <Autocomplete
                              id="subaccount"
                              name="warehouse"
                              options={WarehouseList}
                              getOptionLabel={(option) => option.name}
                              value={WarehouseList.find(w => w.id === wid) || null}
                              onChange={handlewarehouse}
                              renderInput={(params) => (
                                <div ref={params.InputProps.ref}>
                                  <input
                                    type="text"
                                    {...params.inputProps}
                                    style={{
                                      ...styles.input,
                                      ...(errors?.warehouse ? styles.inputError : {})
                                    }}
                                    placeholder="Select org unit"
                                  />
                                </div>
                              )}
                            />
                            {errors?.warehouse && (
                              <div className="UI-error-text">{errors.warehouse}</div>
                            )} */}
                          </div>

                          <div style={styles.formGroup}>
                            <label className="UI-label">Item *</label>
                            <Autocomplete
                              id="subaccount"
                              name="name"
                              options={itemsList}
                              getOptionLabel={(option) => option.name}
                              value={itemsList.find(e => e.id === id) || null}
                              onChange={handleitemname}
                              renderOption={(props, option) => {
                                const stockValue = option.stock ?? 0;
                                const stockStatus = getStockStatus(stockValue);

                                return (
                                  <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>{option.name}</span>
                                    <span style={{ color: stockStatus.style.color, fontSize: '0.8rem' }}>
                                      {stockStatus.text}
                                    </span>
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <div ref={params.InputProps.ref}>
                                  <input
                                    type="text"
                                    {...params.inputProps}
                                    style={{
                                      ...styles.input,
                                      ...(errors?.name ? styles.inputError : {})
                                    }}
                                    placeholder="Select item"
                                  />
                                </div>
                              )}
                            />

                            {errors?.name && (
                              <div className="UI-error-text">{errors.name}</div>
                            )}
                          </div>
                        </>
                      )}

                      {isUpdateMode ||
                        data !== undefined ? (
                        ""
                      ) : (
                        <>
                          <div style={styles.formGroup}>
                            {/* <label style={styles.label}>Brand</label>
                            <input
                              type="text"
                              value={brand}
                              style={{
                                ...styles.input,
                                ...styles.inputDisabled
                              }}
                              disabled
                            /> */}
                            <TextfieldComponent type="text" name={"brand"} value={brand} label="Brand" disabled/>
                          </div>
                          <div style={styles.formGroup}>
                            {/* <label style={styles.label}>Model</label>
                            <input
                              type="text"
                              value={model}
                              style={{
                                ...styles.input,
                                ...styles.inputDisabled
                              }}
                              disabled
                            /> */}
                           <TextfieldComponent type="text" name={"model"} value={model} label="Model" disabled/>

                          </div>
                          <div style={styles.formGroup}>
                            {/* <label style={styles.label}>UOM</label>
                            <input
                              type="text"
                              value={uom}
                              style={{
                                ...styles.input,
                                ...styles.inputDisabled
                              }}
                              disabled
                            /> */}
                            <TextfieldComponent type="text" name={"uom"} value={uom} label="UOM" disabled/>
                          </div>
                        </>
                      )}

                      {/* Price/Cost Field - Editable in both modes */}
                      <div style={styles.formGroup}>
                        {/* <label style={styles.label}>Price *</label> */}
                        {status === "Internal Use" && istatus === "Asset" && assettype === "ThirdParty" ? (
                          // <input
                          //   type="number"
                          //   value={cost}
                          //   onChange={(e) => updateState({ cost: e.target.value })}
                          //   style={{
                          //     ...styles.input,
                          //     ...(errors?.cost ? styles.inputError : {})
                          //   }}
                          //   placeholder="Enter cost"
                          // />
                           <TextfieldComponent type="number" name={"cost"} value={cost} label="Enter Unit Price/Cost" required onChange={(e) => updateState({ cost: e.target.value })} error={errors?.cost}/>
                        ) : (
                                                      <AutoCompeteField id="cost" name="cost" options={costList} label="Unit Cost/Price" labelKey={"rate"} valueKey={"cid"} onChange={handlecost} value={state.cid} required  error={errors?.cost}/>

                          // <Autocomplete
                          //   id="cost-autocomplete"
                          //   name="cost"
                          //   options={costList}
                          //   getOptionLabel={(option) => `${option.rate}`}
                          //   value={selectedPriceOption}
                          //   onChange={handlecost}
                          //   renderInput={(params) => (
                          //     <div ref={params.InputProps.ref}>
                          //       <input
                          //         type="text"
                          //         {...params.inputProps}
                          //         value={cost || ""}
                          //         style={{
                          //           ...styles.input,
                          //           ...(errors?.cost ? styles.inputError : {})
                          //         }}
                          //         placeholder={costList.length > 0 ? "Select price" : "No prices available"}
                          //         readOnly
                          //       />
                          //     </div>
                          //   )}
                          // />
                        )}
                        {/* {errors?.cost && (
                          <div className="UI-error-text">{errors.cost}</div>
                        )} */}
                      </div>

                      {/* Vendor Batch Code Field */}
                      <div style={styles.formGroup}>
                        {/* <label style={styles.label}>Vendor Batch Code</label>
                        <input
                          className="form-control"
                          type="text"
                          name="vendorBatchCode"
                          value={vendorBatchCode}
                          onChange={handlevendorBatchCode}
                          style={styles.input}
                          placeholder="Enter vendor batch code (optional)"
                        />
                        <div style={styles.helperText}>
                          Vendor-provided batch Id or lot number
                        </div> */}

                      <TextfieldComponent type="text" name={"vendorBatchCode"} value={vendorBatchCode} label="Vendor batch code (optional)" onChange={handlevendorBatchCode} error={errors?.vendorBatchCode} />

                      </div>

                      {data !== undefined ? (
                        ""
                      ) : (
                        <div style={styles.formGroup}>
                          <label className="UI-label">Purchase Date</label>
                          <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                            <DatePicker
                              id="date-picker-dialog"
                              format="dd/MM/yyyy"
                              maxDate={new Date()}
                              value={purchasedate}
                              onChange={handlePurchaseDateChange}
                              disabled={isUpdateMode}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={styles.modernDatePicker}
                                  fullWidth
                                />
                              )}
                              autoOk={true}
                              fullWidth
                            />
                          </LocalizationProvider>
                        </div>
                      )}

                      <div style={styles.formGroup}>
                        {/* <label style={styles.label}>Stock *</label>
                        <input
                          className="form-control"
                          id="stock"
                          type="number"
                          name="stock"
                          value={stock}
                          onChange={handleStockChange}
                          onFocus={onstockfocus}
                          disabled={data !== undefined}
                          style={{
                            ...styles.input,
                            ...(errors?.stock ? styles.inputError : {}),
                            ...(data !== undefined ? styles.inputDisabled : {})
                          }}
                        />
                        {errors?.stock && (
                          <div className="UI-error-text">{errors.stock}</div>
                        )} */}

                        <TextfieldComponent type="number" name={"Stock"} value={stock} label="Enter Stock Quantity" required onChange={(e) => updateState({ stock: e.target.value })} error={errors?.stock}/>

                      </div>

                      {/* Min Notifier Field */}
                      <div style={styles.formGroup}>
                        {/* <label style={styles.label}>Minimum Stock Alert</label>
                        <input
                          className="form-control"
                          id="minnotifier"
                          type="number"
                          name="minnotifier"
                          value={minnotifier}
                          onChange={(e) => handleminnotifier(e.target.value)}
                          onFocus={onfocus}
                          style={styles.input}
                          placeholder="Set minimum stock alert level"
                        /> */}
                        <TextfieldComponent type="number" name={"Min Notifier"} value={minnotifier} label="Enter Minimum Stock Alert" required onChange={(e) => updateState({ minnotifier: e.target.value })} error={errors?.minnotifier}/>

                      </div>
                    </div>
                  </div>
                  <div className="UI-form-section">
                    <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Additional Information</h3>

                    {/* Opening Stock Checkbox */}
                    {openingexists && !isUpdateMode && (
                      <div style={{ ...styles.checkboxRow, marginBottom: '0px', marginTop: '20px' }}>
                        <div style={styles.checkboxContainer}>
                          <label style={styles.checkbox}>
                            <input
                              type="checkbox"
                              checked={openingstkstatus}
                              onChange={() =>
                                updateState({
                                  openingstkstatus: !openingstkstatus,
                                  supplier: "",
                                  supplierid: "",
                                })
                              }
                              name="openingstkstatus"
                              style={styles.checkboxInput}
                              disabled={isUpdateMode}
                            />
                            Opening Stock
                          </label>
                        </div>
                      </div>
                    )}

                    {/* Production Byproduct and Supplier Section */}
                    {!openingstkstatus && data === undefined && !isUpdateMode && (
                      <div style={styles.checkboxRow}>
                        <div style={{ ...styles.checkboxContainer, marginTop: '20px' }}>
                          <label style={styles.checkbox}>
                            <input
                              type="checkbox"
                              checked={byproduct}
                              onChange={() =>
                                updateState({
                                  byproduct: !byproduct,
                                  supplier: "",
                                  supplierid: "",
                                })
                              }
                              name="byproduct"
                              style={styles.checkboxInput}
                              disabled={isUpdateMode}
                            />
                            Production Byproduct
                          </label>
                        </div>

                        {!byproduct && (
                          <div style={styles.supplierContainer}>
                            {/* <label style={{ ...styles.label, marginBottom: '0px' }}>Supplier *</label>
                            <Autocomplete
                              id="subaccount"
                              name="supplier"
                              options={suppliers}
                              getOptionLabel={(option) => option.companyname}
                              value={suppliers.find(s => s.id === supplierid) || null}
                              onChange={handlesupplier}
                              renderInput={(params) => (
                                <div ref={params.InputProps.ref}>
                                  <input
                                    type="text"
                                    {...params.inputProps}
                                    style={{
                                      ...styles.input,
                                      ...(errors?.supplier ? styles.inputError : {})
                                    }}
                                    placeholder="Select supplier"
                                  />
                                </div>
                              )}
                            />
                            {errors?.supplier && (
                              <div className="UI-error-text">{errors.supplier}</div>
                            )} */}
                       <AutoCompeteField id="supplier" name="supplier" options={suppliers} label="Supplier" labelKey={"companyname"} valueKey={"id"} onChange={handlesupplier} value={supplierid} required  error={errors.supplier}/>

                          </div>
                        )}
                      </div>
                    )}

                    {/* Manufacture Date Section */}
                    <div style={styles.checkboxRow}>
                      <div style={styles.checkboxContainer}>
                        <label style={styles.checkbox}>
                          <input
                            type="checkbox"
                            checked={addmfdate}
                            onChange={handleaddmfdate}
                            name="parameters"
                            style={styles.checkboxInput}
                            disabled={isUpdateMode}
                          />
                          Add Manufacture date
                        </label>
                      </div>

                      {addmfdate && (
                        <div style={styles.datePickerContainer}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={mfdate}
                              onChange={handleMfDateChange}
                              disabled={isUpdateMode && !addmfdate}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={styles.modernDatePicker}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      )}
                    </div>

                    {/* Expiry Date Section */}
                    <div style={styles.checkboxRow}>
                      <div style={styles.checkboxContainer}>
                        <label style={styles.checkbox}>
                          <input
                            type="checkbox"
                            checked={addexpdate}
                            onChange={handleaddexpdate}
                            name="addecpdate"
                            style={styles.checkboxInput}
                            disabled={isUpdateMode}
                          />
                          Add Expiry date
                        </label>
                      </div>

                      {addexpdate && (
                        <div style={styles.datePickerContainer}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={expdate}
                              onChange={handleExpDateChange}
                              disabled={isUpdateMode && !addexpdate}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={styles.modernDatePicker}
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="UI-form-section">
                    <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Custom Date</h3>

                    <div style={styles.checkboxRow}>
                      <div style={{ ...styles.checkboxContainer, marginTop: '10px' }}>
                        <label style={styles.checkbox}>
                          <input
                            type="checkbox"
                            checked={cdate}
                            onChange={handlecustomDate}
                            name="ordertype"
                            style={styles.checkboxInput}
                          />
                          Custom date?
                        </label>
                      </div>

                      {cdate && (
                        <div style={styles.datePickerContainer}>
                          <label style={styles.label}></label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                              disableFuture
                              showTodayButton
                              showCancelButton
                              variant="inline"
                              id="date-picker-dialog"
                              minDate={
                                transactionFrom
                                  ? dayjs(transactionFrom)
                                  : dayjs('1900-01-01')
                              }
                              maxDate={dayjs()}
                              label="Custom Date"
                              format="DD/MM/YYYY HH:mm"
                              value={customdate ? dayjs(customdate) : null}
                              InputAdornmentProps={{ position: "start" }}
                              onChange={(date) => {
                                console.log("Selected Date:", date ? date.toString() : null);
                                updateState({ customdate: date ? date.toDate() : null });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  sx={styles.modernDatePicker}
                                />
                              )}
                              autoOk={true}
                              disabled={!cdate}
                            />
                          </LocalizationProvider>
                        </div>
                      )}
                    </div>
                  </div>

                  <div style={styles.btnActions}>
                    {/* Cancel Button */}
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="UI-btn UI-btn-outline"
                    >
                      Cancel
                    </button>

                    {/* Save/Update Button */}
                    {loader === true ? (
                      <button
                       className="UI-btn UI-btn-primary"
                        disabled
                      >
                        <Spinner animation="border" size="sm" />
                        &nbsp;{isUpdateMode ? "Updating..." : "Saving..."}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="UI-btn UI-btn-primary"
                      >
                        {isUpdateMode ? "Update" : "Save"}
                      </button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default AddStock;